const API = {
  GETWECHATINVOKESIGN: '/api/wechat/getWechatInvokeSign', // 获取JSAPI签名
  GETWECHATAUTHURI: '/api/wechat/getWechatAuthURI', // 获取授权的URL地址
  LOGINBYOPENTOKEN: '/api/crm/member/loginByOpenToken', // 授权
  WECHATPAY: '/api/wechatpay/webpay', // 微信支付
  ALIPAY: '/api/alipay/webpay', // 支付宝支付
  GETMEMBERBINFO: '/api/crm/member/memberinfo', //获得用户信息
  QUESTIONNAIRELIST: '/api/wj/questionnaire/list', //问卷调查列表
  QUESTIONNAIREQUESTIONLIST: '/api/wj/questionnaire/questionlist', //问卷调查题目列表
  QUESTIONNAIRERESULTLIST: '/api/wj/questionnaire/resultlist', //问卷调查结果
  SAVEWJRESULT: '/api/wj/questionnaire/savewjresult', //提交问卷答案
  EXAMLIST: '/api/edu/exam/list', //模拟考试列表
  EXAMQUESTIONLIST: '/api/edu/exam/questionlist', //模拟考试列表
  EXAMANSWER: '/api/edu/exam/examanswer', //考试答题交卷
  EXAMRESULT: '/api/edu/exam/examresult', //考试答题结果
  ACLIST: '/api/ac/list', //活动列表
  ACFINDACTIVITY: '/api/ac/findActivity', //活动详情
  ACSIGNUPSAVE: '/api/ac/signupsave', //提交报名
  ACTIVITYSIGNUPSAVE: '/api/ac/activitysignupsave', //提交报名
  MEMBERSIGNUPDETAIL: '/api/crm/member/signupdetail', //我的活动详情
  UPDATEWORKTYPE: '/api/crm/member/updateworktype', //修改作品类型
  SENDVCODE: '/api/security/sendvcode', //获取验证码
  BINDPHONENUM: '/api/security/bindPhonenum', //绑定手机号
  LOCALFILE: '/api/toolkit/upload/file', //文件上传
  VODUPLOADSIGN: '/api/toolkit/vod/uploadsign', //获取上传签名
  MEMBERDETAIL: '/api/crm/member/detail', //获取个人信息
  MEMBERACTIVITYLIST: '/api/crm/member/activitylist', //我的报名
  MEMBEREXAMLIST: '/api/crm/member/examlist', //我的考试
  EXAMRECORDDETAIL: '/api/crm/member/examRecordDetail', //我的考试详情
  EXAMRECORDLIST: '/api/crm/member/examRecordlist', //我的考试排行榜
  MEMBERWJLIST: '/api/crm/member/wjlist', //我的问卷
  MEMBERWJRESULTDETAIL: '/api/crm/member/wjresultdetail', //我的问卷详情
  REGISTER: '/api/security/register', //注册
  PSSWORDLOGIN: '/api/security/passwdlogin', //登录
  PRODUCTTYPELIST: '/api/pro/producttypelist', //商城一级栏目
  PRODUCTDETAIL: '/api/pro/productdetail', //商品详情
  PRODUCTLIST: '/api/pro/productlist', //商品列表
  CREATEORDER: '/api/order/createorder', //创建订单
  ORDERDETAIL: '/api/order/detail', //订单详情
  ORDERLIST: '/api/order/list', //订单列表
  CONFIRMRECEIPT: '/api/order/confirmreceipt', //确认收货
  ORDERCANCEL: '/api/order/cancel', //取消订单
  MEMBERADDRESS: '/api/memberaddress/list', //我的收获地址
  MEMBERADDRESSFIND: '/api/memberaddress/findaddress', //新增收货地址
  MEMBERADDRESSCREATE: '/api/memberaddress/create', //新增收货地址
  MEMBERADDRESSUPDATE: '/api/memberaddress/update', //修改收货地址
  MEMBERADDRESSDELETE: '/api/memberaddress/delete', //删除收货地址
  SHENYIGETSHENYI: '/api/shenyi/getshenyi ', //获取会议id接口
  SHENYIMEMBERLOGIN: '/api/shenyi/member/login', // 审议用户登录
  SHENYIFIND: '/api/shenyi/find', // 审议用户信息
  SHENYISAVE: '/api/shenyi/save', // 审议暂存
  SHENYISUBMIT: '/api/shenyi/submit', // 审议保存提交
  // 定制活动
      // （动植物竞赛）
  EDUCONTESTGETEXAM: '/api/edu/contest/getexam', // 查询考试详情
  MEMBERRANKINGLIST: '/api/edu/contest/memberRankingList', // 个人排行榜(包含地区排行榜)
  LISTALLEXAMQUESTION: '/api/edu/contest/listAllExamQuestion', // 查询考试练习题（考试所有题目）
  ADDEXAMMEMBER: '/api/edu/contest/addExamMember', // 参赛用户登记
  CONTESTEXAMRESULT: '/api/edu/contest/examresult', // 考试成绩单(包含当前成绩答案与解析)
  CONTESTEXAMQUESTIONLIST: '/api/edu/contest/examquestionlist', // 根据考试id获取考试题目列表
  CONTESTEXAMANSWER: '/api/edu/contest/examanswer', // 考试答题提交
  GETMEMBERDRAWNUM: '/api/edu/contest/getMemberDrawNum',  // 获取抽奖次数
  MEMBERDRAW: '/api/edu/contest/memberdraw',  // 进行抽奖
  MEMBERDRAWRECORD: '/api/edu/contest/memberdrawrecord', // 抽奖记录
  CONTESTINDEXSHARE: '/api/edu/contest/indexshare', // 分享记录
      // （自然保护地竞赛）
  NATUREEDUCONTESTGETEXAM: '/api/edu/nature/getexam', // 查询考试详情
  NATUREMEMBERRANKINGLIST: '/api/edu/nature/memberRankingList', // 个人排行榜(包含地区排行榜)
  NATURELISTALLEXAMQUESTION: '/api/edu/nature/listAllExamQuestion', // 查询考试练习题（考试所有题目）
  NATUREADDEXAMMEMBER: '/api/edu/nature/addExamMember', // 参赛用户登记
  NATURECONTESTEXAMRESULT: '/api/edu/nature/examresult', // 考试成绩单(包含当前成绩答案与解析)
  NATURECONTESTEXAMQUESTIONLIST: '/api/edu/nature/examquestionlist', // 根据考试id获取考试题目列表
  NATURECONTESTEXAMANSWER: '/api/edu/nature/examanswer', // 考试答题提交
  NATUREGETMEMBERDRAWNUM: '/api/edu/nature/getMemberDrawNum',  // 获取抽奖次数
  NATUREMEMBERDRAW: '/api/edu/nature/memberdraw',  // 进行抽奖
  NATUREMEMBERDRAWRECORD: '/api/edu/nature/memberdrawrecord', // 抽奖记录
  NATURECONTESTINDEXSHARE: '/api/edu/nature/indexshare', // 分享记录
      // （航空科普知识挑战赛）
  AVIATIONGETEXAM: '/api/edu/aviation/getexam', // 查询考试详情
  AVIATIONMEMBERRANKINGLIST: '/api/edu/aviation/memberRankingList', // 个人排行榜(包含地区排行榜)
  AVIATIONLISTALLEXAMQUESTION: '/api/edu/aviation/listAllExamQuestion', // 查询考试练习题（考试所有题目）
  AVIATIONADDEXAMMEMBER: '/api/edu/aviation/addExamMember', // 参赛用户登记
  AVIATIONEXAMRESULT: '/api/edu/aviation/examresult', // 考试成绩单(包含当前成绩答案与解析)
  AVIATIONEXAMQUESTIONLIST: '/api/edu/aviation/examquestionlist', // 根据考试id获取考试题目列表
  AVIATIONEXAMANSWER: '/api/edu/aviation/examanswer', // 考试答题提交
  AVIATIONGETMEMBERDRAWNUM: '/api/edu/aviation/getMemberDrawNum', // 获取用户抽奖次数
  AVIATIONMEMBERDRAW: '/api/edu/aviation/memberdraw', // 用户抽奖
  AVIATIONMEMBERDRAWRECORD: '/api/edu/aviation/memberdrawrecord', // 查询用户中奖纪录
  AVIATIONINDEXSHARE: '/api/edu/aviation/indexshare' // 分享记录
}
export default API